import { render, staticRenderFns } from "./PXCreateQuestionPage.vue?vue&type=template&id=00c68fbc&scoped=true"
import script from "./PXCreateQuestionPage.vue?vue&type=script&lang=js"
export * from "./PXCreateQuestionPage.vue?vue&type=script&lang=js"
import style0 from "./PXCreateQuestionPage.vue?vue&type=style&index=0&id=00c68fbc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c68fbc",
  null
  
)

export default component.exports